import {
  Container,
  FormControl,
  TextField,
  Typography,
  Button,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from "@mui/material";
import { useArtists } from "../../hooks/useArtists";
import useForm from "../../hooks/useForm";
import { useBooking } from "./useBooking";

export const Booking = () => {
  const { artists, error } = useArtists();
  const { onSubmit, isSuccess, isLoading } = useBooking();

  const [formData, handleChange, handleSubmit] = useForm(onSubmit);

  if (error) return "Something went wrong, refresh.";

  return (
    <form onSubmit={handleSubmit}>
      <Container maxWidth="sm" className="mx-auto my-4">
        <div className="flex flex-col mx-auto text-center gap-6 py-4">
          <Typography variant="h4">Book with us</Typography>
          <Typography variant="body1">
            Complete the form below and choose the artist you would like to book
            with.
          </Typography>

          <div className="grid grid-cols-12 gap-2">
            <TextField
              className="col-span-6"
              id="firstName"
              name="firstName"
              label="First Name"
              variant="outlined"
              onChange={handleChange}
              required={true}
            />
            <TextField
              className="col-span-6"
              id="lastName"
              name="lastName"
              label="Last Name"
              variant="outlined"
              onChange={handleChange}
              required={true}
            />
          </div>
          <FormControl>
            <InputLabel id="artist">
              Select the artist you want to book with
            </InputLabel>
            <Select
              value={formData.artist || ""}
              id="artist"
              label="Which artist will be tattoing you?"
              name="artist"
              onChange={handleChange}
              placeholder="Select an artist"
              required={true}
              className="text-left"
            >
              {artists &&
                artists.map((artist) => {
                  return (
                    <MenuItem
                      key={`artistDropdownOption-${artist.Id}`}
                      value={artist.Id}
                    >
                      {artist.Name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
          <FormControl>
            <TextField
              id="emailAddress"
              name="emailAddress"
              label="Email Address"
              type="email"
              variant="outlined"
              onChange={handleChange}
              required={true}
            />
            <Typography
              variant="caption"
              style={{ textAlign: "left", fontStyle: "italic" }}
            >
              This is only used to follow up your enquiry
            </Typography>
          </FormControl>
          <FormControl>
            <TextField
              id="notes"
              name="notes"
              label="Why are you getting in touch?"
              multiline={true}
              minRows="5"
              variant="outlined"
              onChange={handleChange}
              required={true}
            />
          </FormControl>
          <FormControl>
            {isSuccess && (
              <Alert severity="success">
                Booking request sent successfully
              </Alert>
            )}
          </FormControl>
          <FormControl>
            <Button
              disabled={isLoading || isSuccess}
              type="submit"
              variant="contained"
            >
              Send
            </Button>
          </FormControl>
        </div>
      </Container>
    </form>
  );
};
